import React from 'react';
import './RadientBorder.scss';

const RadientBorder = ({ children, style, className, dynamicBorder }) => {
    return (
        <div
            style={style}
            className={`${dynamicBorder == "yes" ? "radiant-no-border-container" : " "
                } ${className ? className : ""} radiant-border-container`}
        >
            {children}
        </div>
    );
};
export default RadientBorder